import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconRotateCounterclockwise$1 = /*@__PURE__*/ proxyCustomElement(class WppIconRotateCounterclockwise extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-rotate-counterclockwise", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10 3.5C13.5899 3.5 16.5 6.41015 16.5 10C16.5 10.4142 16.8358 10.75 17.25 10.75C17.6642 10.75 18 10.4142 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 12.6785 3.31631 15.0485 5.33552 16.5H4.25C3.83579 16.5 3.5 16.8358 3.5 17.25C3.5 17.6642 3.83579 18 4.25 18H7.25C7.66421 18 8 17.6642 8 17.25V14.25C8 13.8358 7.66421 13.5 7.25 13.5C6.83579 13.5 6.5 13.8358 6.5 14.25V15.4784C4.6949 14.3227 3.5 12.3003 3.5 10C3.5 6.41015 6.41015 3.5 10 3.5ZM7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-rotate-counterclockwise-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-rotate-counterclockwise", "wpp-icon-rotate-counterclockwise-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-rotate-counterclockwise-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-rotate-counterclockwise-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconRotateCounterclockwise$1);
      }
      break;
  } });
}

const WppIconRotateCounterclockwise = WppIconRotateCounterclockwise$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconRotateCounterclockwise, defineCustomElement };
